import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useNavigate, useParams } from 'react-router-dom'
import { trocaHorario } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirTrocaDiaTrabalho() {
    const navigate = useNavigate()
    const { id } = useParams<{ id: string }>()

    const { mutate, isLoading } = trocaHorario.diaTrabalho.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!id) return null

    const handleSubmit = () => {
        mutate(Number(id), {
            onSuccess: () => {
                toast.success('Troca de dia de trabalho removida com sucesso!')
                navigate(-1)
            },
            onError: err => {
                if (err.statusCode === 400) {
                    toast.error(err.message)
                } else {
                    toast.error('Erro ao remover troca de dia de trabalho')
                }
            },
        })
    }

    return (
        <ConfirmarExclusao
            permissao={['delete', 'TrocaDeDiaDeTrabalho']}
            loading={isLoading}
            onConfirm={handleSubmit}
            fecharAoConfirmar={false}
            title="Deseja excluir a troca de dia de trabalho?"
        />
    )
}
